var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationRequired({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F5B6B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.134 12.5C24.5189 11.8333 25.4811 11.8333 25.866 12.5L37.9904 33.5C38.3753 34.1667 37.8942 35 37.1244 35H12.8756C12.1058 35 11.6247 34.1667 12.0096 33.5L24.134 12.5Z",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 31,
    r: 2,
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17V27",
    stroke: "#FF0000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationRequired);
export default __webpack_public_path__ + "static/media/validation_required.e9dd43a401650df36e045aa18bebfc22.svg";
export { ForwardRef as ReactComponent };